import { Box, Td, Text, Tr } from "@chakra-ui/react"
import React from "react"
import { COLORS } from "../../../constants/constants"

const LayoverRow = ({ detail }) => {
  return (
    <Tr
      backgroundColor={COLORS.grey}
      boxShadow={"0px 15px 18px 0px rgba(20, 23, 37, 0.13)"}
      position={"relative"}
      zIndex={1}
    >
      <Td colSpan={11} p={{ base: "0!important" }} border={0}>
        <Box
          ml="70px"
          py={2}
          borderTop="1px solid #D4D4D9;"
          borderBottom="1px solid #D4D4D9;"
          fontWeight="semibold"
          fontSize={"12px"}
        >
          <Text>
            Layover: {detail.to_airport} {detail.transition_time}
          </Text>
        </Box>
      </Td>
    </Tr>
  )
}

export default LayoverRow
